import { render, staticRenderFns } from "./EtagList.vue?vue&type=template&id=a8d088f2"
import script from "./EtagList.vue?vue&type=script&lang=js"
export * from "./EtagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports